// extracted by mini-css-extract-plugin
export default {"page":"page-lQMs","center":"center-dunu"};